import React, { useRef } from 'react';
import { Formik, Field } from 'formik';
import { SelectFormField } from '../../../../../components/formFields/SelectFormField';

import useFormRutine from '../../../../../hooks/useForm';
import { InputField } from '../../../../../components/formFields/InputField';
import * as Yup from 'yup';

type AlternativeClassificationFormProps = {
  formProps?: any;
  submitOutside?: boolean;
  submit: (values: any) => void;
  error?: any;
  data?: any[];
};

const AlternativeClassificationForm = ({
  formProps = {},
  submitOutside,
  submit,
  error,
  data,
}: AlternativeClassificationFormProps) => {
  const formRef = useRef<any>();

  useFormRutine(formRef, submitOutside, null, null, null, error);

  const init = (props: any) => {
    if (props) {
      return {
        classification_system: props?.classification_system?.id,
        code: props?.code,
      };
    }
    return {
      classification_system: null,
      code: null,
    };
  };

  const ValidationSchema = Yup.object().shape({
    classification_system: Yup.string().nullable().required('Povinné pole'),
    code: Yup.string().nullable().required('Povinné pole'),
  });

  return (
    <div>
      <Formik
        innerRef={formRef}
        enableReinitialize={true}
        validationSchema={ValidationSchema}
        initialValues={init(formProps)}
        onSubmit={(values) => {
          submit(values);
        }}
      >
        {({ values }) => {
          return (
            <div className="space-y-1">
              {!formProps && (
                <SelectFormField
                  name="classification_system"
                  label="Třídníky"
                  data={data || []}
                  data-testid="alt-classification-form-system-select"
                />
              )}

              <Field
                name="code"
                value={values.code || null}
                component={InputField}
                label="Hodnota"
                data-testid="alt-classification-form-code-input"
              />
            </div>
          );
        }}
      </Formik>
    </div>
  );
};

export default AlternativeClassificationForm;
